module.exports = __webpack_public_path__ + "img/ybhlist.810b8e00.png";